import { CalendarCheck, Radio, RefreshCcw } from 'lucide-react';
import { formatRelative } from '@/shared/lib/format';
import { ChannelKpiTile } from './ChannelKpiTile';

interface Props {
  /** `null`, solange die Kanalliste nicht geladen werden konnte. */
  activeChannelCount: number | null;
  lastPushAt: string | undefined;
  lastBookingAt: string | undefined;
}

/** Die drei Kennzahlen des Kanäle-Reiters. „nie" statt „—", wo es wirklich nie war (§11). */
export function ChannelKpiRow({ activeChannelCount, lastPushAt, lastBookingAt }: Props) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
      <ChannelKpiTile
        icon={<Radio size={13} strokeWidth={2} aria-hidden />}
        iconTint="sage"
        label="Verbunden"
        value={
          activeChannelCount === null
            ? 'unbekannt'
            : `${activeChannelCount} ${activeChannelCount === 1 ? 'Kanal' : 'Kanäle'}`
        }
        muted={activeChannelCount === null}
      />
      <ChannelKpiTile
        icon={<RefreshCcw size={13} strokeWidth={2} aria-hidden />}
        iconTint="amber"
        label="Zuletzt übertragen"
        value={lastPushAt ? formatRelative(lastPushAt) : 'noch nie'}
        muted={!lastPushAt}
      />
      <ChannelKpiTile
        icon={<CalendarCheck size={13} strokeWidth={2} aria-hidden />}
        iconTint="navy"
        label="Letzte Buchung des Objekts"
        value={lastBookingAt ? formatRelative(lastBookingAt) : 'noch keine'}
        muted={!lastBookingAt}
      />
    </div>
  );
}
